function initAiConcierge() {
  document.querySelectorAll('[data-ai-concierge]').forEach((root) => {
    const form = root.querySelector('[data-ai-form]');
    const input = root.querySelector('[data-ai-input]');
    const status = root.querySelector('[data-ai-status]');
    const result = root.querySelector('[data-ai-result]');
    const catalogEl = root.querySelector('[data-ai-catalog]');
    const webhookUrl = root.dataset.webhookUrl || '';
    const catalog = catalogEl ? JSON.parse(catalogEl.textContent) : [];

    if (!form || !input || !status || !result) return;

    root.querySelectorAll('[data-ai-example]').forEach((btn) => {
      btn.addEventListener('click', () => {
        input.value = btn.textContent.trim();
        input.focus();
      });
    });

    function setStatus(state, message) {
      status.dataset.state = state || '';
      status.innerHTML = '';
      if (state === 'loading') {
        status.innerHTML = `<span>${message}</span><span class="ai-concierge__dot" style="animation-delay:0s"></span><span class="ai-concierge__dot" style="animation-delay:0.15s"></span><span class="ai-concierge__dot" style="animation-delay:0.3s"></span>`;
      } else if (message) {
        status.textContent = message;
      }
    }

    function renderResult(data) {
      result.hidden = false;
      result.querySelector('[data-ai-result-badge]').textContent = data.badge || 'Recommended for you';
      result.querySelector('[data-ai-result-title]').textContent = data.title || '';
      result.querySelector('[data-ai-result-reason]').textContent = data.reason || '';

      const img = result.querySelector('[data-ai-result-image]');
      if (data.image) {
        img.src = data.image;
        img.hidden = false;
      } else {
        img.hidden = true;
      }

      const specsWrap = result.querySelector('[data-ai-result-specs]');
      specsWrap.innerHTML = '';
      const specs = data.specs || {};
      const labels = { power: 'Power', speed: 'Speed', range: 'Range' };
      Object.keys(labels).forEach((key) => {
        if (!specs[key]) return;
        const cell = document.createElement('div');
        cell.className = 'ai-concierge__result-spec';
        cell.innerHTML = `<p>${labels[key]}</p><strong>${specs[key]}</strong>`;
        specsWrap.appendChild(cell);
      });

      const cta = result.querySelector('[data-ai-result-cta]');
      if (data.url) {
        cta.href = data.url;
        cta.hidden = false;
      } else {
        cta.hidden = true;
      }
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const query = input.value.trim();
      if (!query) return;

      result.hidden = true;

      if (!webhookUrl) {
        setStatus(
          'unconfigured',
          'This search isn’t connected to an AI backend yet. Set the webhook URL in the section settings from the Theme Editor.'
        );
        return;
      }

      setStatus('loading', 'Analysing our catalogue');

      try {
        const response = await fetch(webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query, catalog }),
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        setStatus('', '');
        renderResult(data);
      } catch (error) {
        setStatus('error', 'We couldn’t reach the AI right now. Please try again shortly.');
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAiConcierge);
} else {
  initAiConcierge();
}
